import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useRef, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router'
import { FilterMatchMode } from "primereact/api"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { handleLoader, handleNotFound, setSelectedConnector } from 'redux/counterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getConfigData, getConfigDataByID, loginConfig, saveConfig, getConnectorsDropdownData, getConnectorsKeysData } from 'services/pdfUploadService';
import { Dropdown } from 'primereact/dropdown';
import { useParams } from 'react-router-dom';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { CloseEyeIcon, datatableEdit, datatableEditHover, datatableView, datatableViewHover, eyeIcon } from 'assets/icons';
import { Sidebar } from 'primereact/sidebar';
import { InputTextarea } from 'primereact/inputtextarea';
import { useForm } from 'react-hook-form';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import SharePointConnector from './SharepointConnector';

const PdfUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm<any>()

  const selectedConnector = useSelector((state: any) => state.counter.selectedConnector);
  const userName = localStorage.getItem("username")
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState<{ [s: string]: any }>();
  const [list, setList] = useState([]);
  const [connectorsList, setConnectorsList] = useState([
    { "name": "amazons3", "code": "Amazon S3" },
    { "name": "SFTP", "code": "SFTP" },
    { "name": "sharepoint", "code": "SharePoint" },
  ]);
  const [selectedCity, setSelectedCity] = useState({ name: 'SFTP', code: 'SFTP' });
  const [selectedCityAddUpdate, setSelectedCityAddUpdate] = useState({ name: 'SFTP', code: 'SFTP' });
  const [showPassword, setShowPassword] = useState(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [is_edit, setIs_edit] = useState<string>("");
  const [keys, setKeys] = useState([]);
  const [loginKeys, setLoginKeys] = useState([]);
  // const [selectedCity2, setSelectedCity2] = useState({ name: 'SFTP', code: 'NY' });
  const [destinationPath, setDestinationPath] = useState("");
  const dataTableRef = useRef<any>(null);
  const [globalFilterFields, setGlobalFilterFields] = useState<any>([]);
  const [first, setFirst] = useState(0); // State to control the first page
  const [sortField, setSortField] = useState(""); // State to control the first page
  const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
  const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
  // const cities2 = [
  //     { name: 'SFTP', code: 'NY' },
  //     { name: 'Rome', code: 'RM' },
  //     { name: 'London', code: 'LDN' },
  //     { name: 'Istanbul', code: 'IST' },
  //     { name: 'Paris', code: 'PRS' }
  // ];


  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }

  const secretKey = 'RONSFTPCONNECTOR';
  const iv = 'BBBBBBBBBBBBBBBB';

  const cities = [
    { name: 'SFTP', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' }
  ];

  const sftpColumns = [
    { field: 'username', header: 'User Name', sortable: true },
    { field: 'hostname', header: 'Host Name', sortable: true },
    { field: 'port', header: 'Port', sortable: true },
    { field: 'hosturl', header: 'Host URL', sortable: true },
    { field: 'source_path', header: 'Source Path', sortable: true },
    { field: 'destination_path', header: 'Destination Path', sortable: true }
  ];

  const sharepointColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'sharepoint_site_url', header: 'Sharepoint Site URL', sortable: true },
    { field: 'sharepoint_folder_relative_url', header: 'Sharepoint Folder Relative URL', sortable: true }
  ];

  const googleDriveColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'json', header: 'Json', sortable: true },
    { field: 'scopes', header: 'Scopes', sortable: true },
  ];

  const confluenceColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'confluence_url', header: 'Confluence URL', sortable: true },
    { field: 'space_key', header: 'Space Key', sortable: true },
  ];

  const amazons3Columns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'aws_region', header: 'AWS Region', sortable: true },
    { field: 'bucket_name', header: 'Bucket Name', sortable: true },
  ];

  const dropboxColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'app_key', header: 'App Key', sortable: true },
    { field: 'refresh_token', header: 'Refresh Token', sortable: true },
  ];

  const salesforceColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'security_token', header: 'Security Token', sortable: true },
  ];

  const servicenowColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'instance_url', header: 'Instance URL', sortable: true },
    { field: 'table_name', header: 'Table Name', sortable: true },
  ];

  const jiraColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'jira_username', header: 'Jira Name', sortable: true },
    { field: 'jira_url', header: 'Jira URL', sortable: true }
  ];

  const freshserviceColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'domain', header: 'Domain', sortable: true },
  ];

  const zendeskColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'email', header: 'Email', sortable: true },
    { field: 'subdomain', header: 'Subdomain', sortable: true }
  ];

  const gmailColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'email_user', header: 'Email', sortable: true },
    { field: 'imap_server', header: 'Server', sortable: true }
  ];

  const asanaColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'asana_access_token', header: 'Access Token', sortable: true }
  ];
  const azureblobColumns = [
    { field: 'client_name', header: 'Client Name', sortable: true },
    { field: 'container_name', header: 'Container Name', sortable: true },
    { field: 'blob_account_name', header: 'Blob Account Name', sortable: true },
  ];

  const dynamicColumns = selectedCity?.name === "SFTP"
    ? sftpColumns
    : selectedCity?.name === "sharepoint"
      ? sharepointColumns
      : selectedCity?.name === "googledrive"
        ? googleDriveColumns
        : selectedCity?.name === "confluence"
          ? confluenceColumns
          : selectedCity?.name === "amazons3"
            ? amazons3Columns
            : selectedCity?.name === "dropbox"
              ? dropboxColumns
              : selectedCity?.name === "salesforce"
                ? salesforceColumns
                : selectedCity?.name === "servicenow"
                  ? servicenowColumns
                  : selectedCity?.name === "jira"
                    ? jiraColumns
                    : selectedCity?.name === "freshservice"
                      ? freshserviceColumns
                      : selectedCity?.name === "zendesk"
                        ? zendeskColumns
                        : selectedCity?.name === "gmail"
                          ? gmailColumns
                          : selectedCity?.name === "asana"
                            ? asanaColumns
                            : selectedCity?.name === "azureblob"
                              ? azureblobColumns
                              : []

  useEffect(() => {
    if (globalFilterValue) {
      const fields = dynamicColumns.map((col) => col.field);
      setGlobalFilterFields(fields);
    }
  }, [dynamicColumns]);

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFirst(0);
    const value = e?.target?.value
    let _filters = { ...filters }

    _filters["global"]!.value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }
  const handleSort = (event: any) => {
    setSortField(event.sortField)
    setSortOrder(event.sortOrder)
    setFirst(0);  //Move to page 1
    // dispatch(setFirstVoice(0)); // Move to page 1
  };
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
    setGlobalFilterValue("")
  }

  const getData = async (data: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getConfigData(data);
      // const { result, error } = await getConfigData(params["*"] === "pdf-upload" ? 'sftp_doc' : "sftp_voice");
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      dispatch(handleLoader(false));
      setList(result);
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const handleConnectorName = (c_name: string) => {
    switch (c_name) {
      case 'amazons3':
        return 'Amazon S3';
      case 'servicenow':
        return 'ServiceNow';
      case 'sharepoint':
        return 'SharePoint';
      case 'azureblob':
        return 'Azure Blob';
      default:
        return c_name.charAt(0).toUpperCase() + c_name.slice(1)
    }
  }

  const getDropdownData = async () => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getConnectorsDropdownData();
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      dispatch(handleLoader(false));
      const dropdownItems = result?.get_dropdown_keys
        ?.map((key: string) => {
          // if (key === "amazons3") {
          //   return {
          //     name: key,
          //     code: "Amazon S3",
          //   };
          // } else {
          return {
            name: key,
            code: handleConnectorName(key),
          };
          // }
        })
        ?.sort((a: any, b: any) => a.name.localeCompare(b.name));
      setConnectorsList(dropdownItems);
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const handleChangeConnector = (value: any) => {
    getData(value?.name);
    const modifiedValue = value?.name === "SFTP" ? "sftp_doc" : value?.name
    getConnectorsKeys(modifiedValue);
    setGlobalFilterValue("")
    dispatch(setSelectedConnector(value?.name));
    setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } })
    if (dataTableRef.current) {
      dataTableRef.current.reset();
    }
  }

  useEffect(() => {
    if (selectedConnector) {
      setSelectedCity({ name: selectedConnector, code: handleConnectorName(selectedConnector) });
      setSelectedCityAddUpdate({ name: selectedConnector, code: handleConnectorName(selectedConnector) })
      getConnectorsKeys(selectedConnector)
    }
  }, [selectedConnector]);

  useEffect(() => {
    // getDropdownData()
    getData(selectedConnector ? selectedConnector : selectedCity?.name);
    initFilters()
  }, [params['*'], selectedConnector]);

  useEffect(() => {
    dispatch(handleNotFound(false));
  }, [])

  const customHeader = () => {
    if (is_edit === "") {
      return (
        <div className="flex align-items-center gap-2">
          Add Configuration
        </div>
      )
    } else {
      return (
        <div className="flex align-items-center gap-2">
          Edit Configuration
        </div>
      )
    }
  }
    ;

  // Add-Update part
  // Function to encrypt the password
  const encryptPassword = (password: string) => {
    // Replace 'your-secret-key' with your own secret key
    // Encrypt the password using AES encryption with the secret key
    const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.ECB
    });
    return encrypted.toString();
  };

  // Function to decrypt the password
  const decryptPassword = (encryptedPassword: string) => {
    try {
      const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);

      // Decrypt using AES with ECB mode
      const decrypted = CryptoJS.AES.decrypt(encryptedPassword, parsedKey, {
        mode: CryptoJS.mode.ECB
      });
      // Convert decrypted data to UTF-8 string
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Error decrypting data:', error);
      return '';
    }
  };
  const getConnectorsKeys = async (data: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getConnectorsKeysData(data);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      dispatch(handleLoader(false));
      let valuesToRemove = ["objectid", "connector_name", "file_extension", "login_username", "created_by", "updated_by"];
      const modifiedKeys: any = _.without(result?.get_keys_for_update, ...valuesToRemove);
      setKeys(modifiedKeys);
      setLoginKeys(result?.get_keys_for_login)
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const getDataById = async (id: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getConfigDataByID(id as string);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      setIs_edit(id);
      setVisible(true);
      if (result?.source === "sftp_doc") {
        setSelectedCityAddUpdate({ name: 'SFTP', code: 'SFTP' })
      } else {
        setSelectedCityAddUpdate({ name: result?.connector_name, code: handleConnectorName(result?.connector_name) })
      }
      getConnectorsKeys(result?.connector_name)
      const decryptedResult = { ...result };
      Object.keys(decryptedResult).forEach((key) => {
        if (key.includes('secret') || key.includes('password')) {
          decryptedResult[key] = decryptPassword(decryptedResult[key]);
        }
      });
      reset(decryptedResult)
      dispatch(handleLoader(false));
      // setValue("username", result.username);
      // setValue("destination_path", result.destination_path);
      // setDestinationPath(result.destination_path);
      // setValue("hostname", result.hostname);
      // setValue("hosturl", result.hosturl);
      // const decryptedPassword = decryptPassword(result?.password);
      // setValue("password", decryptedPassword);
      // setValue("port", result.port);
      // setValue("remarks", result.remarks);
      // setValue("client_env", result.client_env);
      // setValue("source_path", result.source_path);
      // setValue("file_transfer_path", result.file_transfer_path);
      // setValue("unprocess_file_path", result.unprocess_file_path);
      // setValue("process_file_path", result.process_file_path);
      // setValue("error_file_path", result.error_file_path);
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }
  // Watch the 'destination_path' field and log its value
  const watchedValue = watch('destination_path');

  const handleAddUpdateEdit = () => {
    setIs_edit("")
  }

  const onSubmit = async (data: any) => {
    data.password = encryptPassword(data.password);
    if (is_edit === "") {
      delete data.updated_by
      data.source = "sftp_doc"
      data.file_extension = [".pdf", ".doc", ".docx", ".csv", ".txt", ".xlsx"]
      // data.file_extension = [".mp4",".mp3",".wav"] // for voice
      // data.source = params["*"] === "pdf-upload" ? "sftp_doc" : "sftp_voice"
      data.created_by = userName
      dispatch(handleLoader(true));
      try {
        const { result, error } = await saveConfig(data);
        if (error) {
          throw error
        }
        if (result?.error) {
          throw result.error
        }
        getData(selectedCityAddUpdate?.name);
        dispatch(setSelectedConnector(selectedCityAddUpdate?.name))
        toast.success(result.message, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        setVisible(false);
      } catch (error: any) {
        dispatch(handleLoader(false));
        toast.error(error, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      }
    } else {
      delete data.created_by
      data.source = "sftp_doc";
      data.file_extension = [".pdf", ".doc", ".docx", ".csv", ".txt", ".xlsx"]
      // data.file_extension = [".mp4",".mp3",".wav"] // for voice
      // data.source = "pdf-upload" ? "sftp_doc" : "sftp_voice";
      data.objectid = is_edit;
      // delete data.client_env
      dispatch(handleLoader(true));
      data.updated_by = userName
      try {
        const { result, error } = await saveConfig(data);
        if (error) {
          throw error
        }
        if (result?.error) {
          throw result.error
        }
        getData(selectedCityAddUpdate?.name);
        dispatch(setSelectedConnector(selectedCityAddUpdate?.name))
        setVisible(false);
        toast.success(result.message, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      } catch (error: any) {
        dispatch(handleLoader(false));
        toast.error(error, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      }
    }
  }

  const handleChangeConnectorAddUpdate = (value: any) => {
    const modifiedValue = value?.name === "SFTP" ? "sftp_doc" : value?.name
    getConnectorsKeys(modifiedValue)
  }

  // Function to clear validation errors on change
  const clearValidationErrorsOnChange = (fieldName: string) => {
    clearErrors(fieldName);
  };

  const handleTest = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['hosturl', 'port', 'username', 'password']);
    if (isValid) {
      const temp = {} as { hosturl: string, port: string, username: string, password: string };
      temp.hosturl = getValues("hosturl");
      temp.port = getValues("port");
      temp.username = getValues("username");
      temp.password = encryptPassword(getValues("password"));
      dispatch(handleLoader(true));
      try {
        const { result, error } = await loginConfig(temp);
        if (error) {
          throw error
        }
        if (result?.error) {
          throw result.error
        }
        dispatch(handleLoader(false));
        toast.success(result.message, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
        // navigate("/file-config");
      } catch (error: any) {
        dispatch(handleLoader(false));
        toast.error(error, {
          style: {
            backgroundColor: '#F1F1F1', // Grey background
          }
        });
      }
    }
  }
  const isPasswordRequired = params.id !== "login" ? true : false;
  const passwordValidation = (val: string) => {
    return isPasswordRequired
      ? {
        required: {
          value: true,
          message: `${val} is required`,
        },
      }
      : {}
  };
  const onCancel = () => {
    setDestinationPath("");
    setValue("username", "");
    setValue("destination_path", "");
    setValue("hostname", "");
    setValue("hosturl", "");
    setValue("password", "");
    setValue("port", "");
    setValue("remarks", "");
    setValue("client_env", "");
    setValue("source_path", "");
    setValue("file_transfer_path", "");
    setValue("unprocess_file_path", "");
    setValue("process_file_path", "");
    setValue("error_file_path", "");
    setVisible(false);
    setIs_edit("");
    setSelectedCityAddUpdate(selectedCity)
    getConnectorsKeys(selectedCity.name)
    clearErrors();
  }

  return (
    <>
      <div className="datatable-wrapper">
        <div className="p-4 content-wrapper">
          <div className="switch-section user-management-section">
            <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
              <h4 className="mb-0">Connectors</h4>
              <div className="d-flex justify-content-between align-items-center table-right-row">
                <div className='d-flex align-items-center table-right-first'>
                  <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                    <IconField iconPosition="right" className='user-input'>
                      <InputIcon className="pi pi-search"></InputIcon>
                      <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search by config details"
                      />
                    </IconField>
                  </div>
                  <Button label="Add Configuration" outlined icon="pi pi-plus" className='outline-icon-btn mr-3 mt-1 mb-1' onClick={() => setVisible(true)}></Button>
                  <div className='table-right-end mt-1 mb-1'>
                    {/* onClick={async () => navigate("/admin/pdf-upload/add")} */}
                    <Dropdown resetFilterOnHide={true} autoOptionFocus={true} value={selectedCity} onChange={(e) => { setSelectedCity(e.value); setSelectedCityAddUpdate(e.value); handleChangeConnector(e.value) }} options={connectorsList} optionLabel="code"
                      placeholder="Select connector" className="outline-select w-9rem" />
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              ref={dataTableRef}
              paginator
              filters={filters}
              globalFilterFields={globalFilterFields}
              first={first}
              onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
              rows={rowsPerPage}
              sortField={sortField}
              sortOrder={sortOrder}
              sortMode="single"
              onSort={handleSort}
              rowsPerPageOptions={[5, 10, 25]}
              stripedRows
              value={list}
              tableStyle={{}}
              emptyMessage="No configuration records found"
            >
              {/* <Column field="username" header="User Name" sortable></Column>
              <Column
                field="hostname"
                header="Host Name"
                sortable
              ></Column>
              <Column
                field="port"
                header="Port"
                sortable
              ></Column>
              <Column
                field="hosturl"
                header="Host URL"
                sortable
              ></Column>
              <Column
                field="source_path"
                header="Source Path"
                sortable
              ></Column>
              <Column
                field="destination_path"
                header="Destination Path"
                sortable
              ></Column>
              <Column header="Action" body={ActionButton(navigate, getDataById)}></Column> */}
              {(selectedCity?.name === "SFTP"
                ? sftpColumns
                : selectedCity?.name === "sharepoint"
                  ? sharepointColumns
                  : selectedCity?.name === "googledrive"
                    ? googleDriveColumns
                    : selectedCity?.name === "confluence"
                      ? confluenceColumns
                      : selectedCity?.name === "amazons3"
                        ? amazons3Columns
                        : selectedCity?.name === "dropbox"
                          ? dropboxColumns
                          : selectedCity?.name === "salesforce"
                            ? salesforceColumns
                            : selectedCity?.name === "servicenow"
                              ? servicenowColumns
                              : selectedCity?.name === "jira"
                                ? jiraColumns
                                : selectedCity?.name === "freshservice"
                                  ? freshserviceColumns
                                  : selectedCity?.name === "zendesk"
                                    ? zendeskColumns
                                    : selectedCity?.name === "gmail"
                                      ? gmailColumns
                                      : selectedCity?.name === "asana"
                                        ? asanaColumns
                                        : selectedCity?.name === "azureblob"
                                          ? azureblobColumns
                                          : []).map((col, i) => (
                                            <Column key={col.field} field={col.field} header={col.header} sortable />
                                          ))}
              <Column header="Action" body={ActionButton(navigate, getDataById)}></Column>
            </DataTable>
            <Sidebar position="right" header={customHeader} visible={visible} onHide={onCancel} className='form-sidebar add-config-sidebar' style={{ width: '810px' }}>
              {selectedCityAddUpdate.name === "SFTP" ?
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-sidebar-body">
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Date Source Type</label>
                        <Dropdown resetFilterOnHide={true} disabled={is_edit !== "" ? true : false} value={selectedCityAddUpdate} onChange={(e) => { setSelectedCityAddUpdate(e.value); handleChangeConnectorAddUpdate(e.value) }} options={connectorsList} optionLabel="code" />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Host URL<i>*</i></label>
                        <InputText
                          //
                          {...register("hosturl", {
                            required: {
                              value: true,
                              message: "Host URL is required",
                            },
                          })}
                          onChange={() => clearValidationErrorsOnChange('hosturl')}
                          placeholder="Host URL"
                        />
                        {getFormErrorMessage("hosturl")}
                      </div>
                      <div className='form-col'>
                        <label className="form-label">Port<i>*</i></label>
                        <InputText
                          type='number'
                          //
                          {...register("port", {
                            required: {
                              value: true,
                              message: "Port is required",
                            },
                          })}
                          placeholder="Port"
                          onChange={() => clearValidationErrorsOnChange('port')}
                        />
                        {getFormErrorMessage("port")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">User Name<i>*</i></label>
                        <InputText
                          //
                          {...register("username", {
                            required: {
                              value: true,
                              message: "Username is required",
                            },
                          })}
                          placeholder="Username"
                          onChange={() => clearValidationErrorsOnChange('username')}
                          autoComplete="new-password"
                        />
                        {getFormErrorMessage("username")}
                      </div>
                      <div className='form-col'>
                        <label className="form-label">Password<i>*</i></label>
                        <div className='d-flex position-relative'>
                          <InputText
                            className=""
                            type={showPassword ? "text" : "password"}
                            {...register("password", {
                              required: {
                                value: true,
                                message: `Password is required`,
                              },
                            })}
                            placeholder="Enter your Password"
                            autoComplete="new-password"
                            onChange={() => clearValidationErrorsOnChange('password')}
                          />
                          <span className={`password-toggle2 c-pointer `} onClick={() => setShowPassword(!showPassword)}>
                            {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                              <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                            }
                          </span>
                        </div>
                        {getFormErrorMessage("password")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Host Name<i>*</i></label>
                        <InputText
                          {...register("hostname", passwordValidation("Host Name"))}
                          placeholder="Host Name"
                        />
                        {getFormErrorMessage("hostname")}
                      </div>
                      <div className='form-col'>
                        <label className="form-label">ENV<i>*</i></label>
                        <InputText
                          {...register("client_env", passwordValidation("ENV"))}
                          placeholder="ENV"
                        />
                        {getFormErrorMessage("client_env")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Source Path<i>*</i></label>
                        <InputText
                          {...register("source_path", passwordValidation("Source Path"))}
                          placeholder="Source Path"
                        />
                        {getFormErrorMessage("source_path")}
                      </div>
                      <div className='form-col'>
                        <label htmlFor="file_transfer_path" className="form-label">
                          Source File Transfer Path<i className="text-red-600">*</i>
                        </label>
                        <InputText
                          {...register("file_transfer_path", passwordValidation("Source File Transfer Path"))}
                          placeholder="Source File Transfer Path"
                        />
                        {getFormErrorMessage("file_transfer_path")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Destination Path<i>*</i></label>
                        <InputText
                          {...register("destination_path", passwordValidation("Destination Path"))}
                          placeholder="Destination Path"
                        />
                        {getFormErrorMessage("destination_path")}
                      </div>
                      <div className='form-col'>
                        <label className="form-label">Processed File Path<i>*</i></label>
                        <div className="wrapper w-full">
                          <span className="sufix">{watchedValue}</span>
                          <InputText
                            className="w-full"
                            {...register("process_file_path", passwordValidation("Processed File Path"))}
                            placeholder="Processed File Path"
                          />
                        </div>
                        {getFormErrorMessage("process_file_path")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label className="form-label">Unrocessed File Path<i>*</i></label>
                        <div className="wrapper w-full">
                          <span className="sufix">{watchedValue}</span>
                          <InputText
                            className="w-full"
                            {...register("unprocess_file_path", passwordValidation("Unprocessed File Path"))}
                            placeholder="Unprocessed File Path"
                          />
                        </div>
                        {getFormErrorMessage("unprocess_file_path")}
                      </div>
                      <div className='form-col'>
                        <label className="form-label">Error File Path<i>*</i></label>
                        <div className="wrapper w-full">
                          <span className="sufix">{watchedValue}</span>
                          <InputText
                            className="w-full"
                            {...register("error_file_path", passwordValidation("Error File Path"))}
                            placeholder="Error File Path"
                          />
                        </div>
                        {getFormErrorMessage("error_file_path")}
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col w-100'>
                        <label className="form-label">Remark<i>*</i></label>
                        <InputTextarea style={{ height: '90px' }}
                          {...register("remarks")}
                          placeholder="Add remark here..."
                        />
                        {/* {getFormErrorMessage("remark")} */}
                      </div>
                    </div>
                  </div>
                  <div className='form-sidebar-footer'>
                    <Button className='grey-outline-btn mr-3' label='Cancel' type='button' onClick={onCancel}></Button>
                    <Button className='grey-outline-btn mr-3' label='Test' type='button' onClick={handleTest}></Button>
                    <Button className='outline-active-btn' label='Save' type='submit'></Button>
                  </div>
                </form> :
                <SharePointConnector setSelectedCity={setSelectedCity} setVisible={setVisible} getData={getData} id={is_edit} onCancel={onCancel} connectorsList={connectorsList} setSelectedCityAddUpdate={setSelectedCityAddUpdate} selectedcity={selectedCityAddUpdate} keys={keys} loginKeys={loginKeys} handleChangeConnector={handleChangeConnectorAddUpdate} handleAddUpdateEdit={handleAddUpdateEdit} />
              }
            </Sidebar>
          </div>
        </div>
      </div >
    </>
  )
}

export default PdfUpload

function ActionButton(navigate: NavigateFunction, getDataById: (id: string) => Promise<void>) {
  const params = useParams();
  const [is_hover_eye, setIs_hover_eye] = useState<string>("");
  const [is_hover_Edit, setIs_hover_Edit] = useState<string>("");
  return (rowData: { [s: string]: string }) => {


    return (
      <div className='d-flex'>
        <span
          className="mr-3 cursor-pointer"
          onClick={() => getDataById(rowData._id)}
          // onClick={() => navigate(`/admin/pdf-upload/${rowData._id}`)}
          onMouseEnter={() => setIs_hover_Edit(rowData._id)} onMouseLeave={() => setIs_hover_Edit("")}
        // onClick={() => { params["*"] === "pdf-upload" ? navigate(`/admin/pdf-upload/${rowData._id}`) : navigate(`/admin/voice-upload/${rowData._id}`) }}
        // disabled={!permissions.edit}
        >
          <img src={is_hover_Edit === rowData._id ? datatableEditHover : datatableEdit} alt='edit-icon' />
        </span>
        {
          params["*"] !== "voice-upload" &&
          <span
            className='cursor-pointer'
            onClick={() => { navigate(`/admin/pdf-upload/file-config`, { state: rowData }); localStorage.setItem("hosturl", rowData.hosturl) }}
            onMouseEnter={() => setIs_hover_eye(rowData.website_id)} onMouseLeave={() => setIs_hover_eye("")}
          // onClick={() => { params['*'] === "pdf-upload" ? navigate(`/admin/pdf-upload/file-config`) : navigate(`/admin/voice-upload/file-config`); localStorage.setItem("hosturl", rowData.hosturl) }}
          // disabled={!permissions.edit}
          >
            <img src={is_hover_eye === rowData.website_id ? datatableViewHover : datatableView} alt='view-icon' />
          </span>
        }
      </div >
    )
  }
}